import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './CustomInput.css';

export const CustomInput = React.forwardRef(({className, action, error, ...props}, ref) => (
  <div className="CustomInput">
    <input
      ref={ref}
      className={classnames(
        'CustomInput-input',
        className,
        {
          'CustomInput-input-error': error
        }
      )}
      {...props}
    />
    {action}
  </div>
));

CustomInput.propTypes = {
  className: PropTypes.string,
  action: PropTypes.element,
  error: PropTypes.bool
};

CustomInput.defaultProps = {
  className: ''
};

export default CustomInput;
